<template>
  <div name="demo-table-row-condition-approve">
    <label class="color-skin align-center">Status Approve Condition</label>
    <hrms-table :columns="columns[nowLang].index"
                :data="index"
                :indexDisp="true"
                :approveDisp="true"
                :approveBtnDisp="true"
                :approveEvent="approveEvent"
                :detailEvent="detailEvent"
                :nowLang="nowLang" />

    <label class="color-skin align-center">Status Approve + Custom Condition</label>
    <hrms-table :columns="columns[nowLang].index"
                :data="index"
                :indexDisp="true"
                :approveDisp="true"
                :approveBtnDisp="true"
                :approveEvent="approveEvent"
                :detailEvent="detailEvent"
                :nowLang="nowLang"
                :rowDisableCondition="rowDisableCondition" />
  </div>
</template>

<script>
import mock from './mockTableData.js'

let labels = mock.approveLabels
let flgRowCondition = true
let mockColumns = mock.columns(labels, 'approve', flgRowCondition)
let mockData = mock.dataApprove(flgRowCondition)

export default {
  name: 'demo-table-row-condition-approve',
  data () {
    return {
      nowLang: 'en',
      columns: {
        en: { index: mockColumns },
        th: { index: mockColumns }
      },
      index: mockData
    }
  },
  methods: {
    detailEvent (dataRow) {
      console.log('Detail Event')
    },
    approveEvent (dataRow) {
      console.log('Approve Event')
    },
    rowDisableCondition (dataRow) {
      return dataRow.rowID % 3 > 0
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoTableRowConditionApprove.vue?03a02961